<script>
    import IconTooltip from "../../../common/icon-tooltip.vue";

    export default {
        name: "publish-buttons",
        components: {IconTooltip},
        props: {
            disableSave: Boolean,
            approvePrivilege: Boolean,
            publishPrivilege: Boolean,
            updateApprove: Number,
            updatePublish: Number,
            saving: Boolean,
            confirmText: {
                type: String,
                default: Lang.langGet("Save")
            }
        },
        computed: {
            translation() {
                return {
                    approve: Lang.langGet("Approve"),
                    publish: Lang.langGet("Publish"),
                    autoApprove: Lang.langGet("The modified content gets approved in all layers."),
                    autoKeepApproved: Lang.langGet("Approved state of layer elements is not changed."),
                    autoDisapprove: Lang.langGet("Layer elements that contain the modified content get disapproved."),
                    autoPublish: Lang.langGet("Layers that contain the modified content get published to the relevant screens."),
                    autoNotPublish: Lang.langGet("Layer elements do not get published."),
                }
            },
            approveIconClass() {
                if (this.updateApprove === 0) {
                    return 'fa-square-minus fa-regular';
                }
                if (this.updateApprove === 1) {
                    return 'fa-square-check fa-regular'
                }
                return 'fa-square fa-regular';
            },
            approveTooltip() {
                if (this.updateApprove === 0) {
                    return this.translation.autoKeepApproved;
                }
                if (this.updateApprove === 1) {
                    return this.translation.autoApprove;
                }
                return this.translation.autoDisapprove;
            },
            publishIconClass() {
                if (this.updatePublish === 0) {
                    return 'fa-square fa-regular';
                }
                return 'fa-square-check fa-regular';
            },
            publishTooltip() {
                if (this.updatePublish === 0) {
                    return this.translation.autoNotPublish;
                }
                return this.translation.autoPublish;
            }
        },
        methods: {
            handleConfirm(approve, publish) {
                this.$emit('confirm',approve,publish);
            },
            cycleUpdateApprove() {
                this.$emit('cycleUpdateApprove');
            },
            cycleUpdatePublish() {
                this.$emit('cycleUpdatePublish');
            },
        }
    }
</script>

<template>
    <div class="d-flex flex-row btn-group">
        <template v-if="approvePrivilege">
            <div class="btn-group actions">
                <v-btn :disabled="disableSave || saving"
                       class="border-right-radius-4 btn-group btn btn-primary v-btn v-btn--is-elevated v-btn--has-bg theme--light submit"
                       aria-label="save"
                       @click="handleConfirm(updateApprove, updatePublish)">
                    {{ confirmText }}
                </v-btn>
                <div class="btn-group border-left">
                    <v-menu :disabled="disableSave || saving" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                :disabled="disableSave || saving"
                                class="border-right-radius-4 btn-group btn btn-primary v-btn v-btn--is-elevated v-btn--has-bg theme--light submit"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <span class="caret"></span>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <div class="flex-md-row" @click.stop="cycleUpdateApprove()">
                                    <div class="col-md-3">
                                        <i :class="approveIconClass"/>
                                    </div>

                                    <div class="col-md-6">{{ translation.approve }}</div>

                                    <div class="col-md-3">
                                        <icon-tooltip :hintText="approveTooltip"/>
                                    </div>
                                </div>
                            </v-list-item>
                            <v-list-item v-if="publishPrivilege">
                                <div class="flex-md-row"
                                     @click.stop="cycleUpdatePublish()"
                                >
                                    <div class="col-md-3">
                                        <i :class="publishIconClass"/>
                                    </div>

                                    <div class="col-md-6">{{ translation.publish }}</div>
                                    <div class="col-md-3">
                                        <icon-tooltip :hintText="publishTooltip"/>
                                    </div>
                                </div>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </template>
        <template v-else>
            <v-btn :disabled="disableSave || saving"
                   class="btn btn-primary submit mr-1"
                   aria-label="save"
                   @click="handleConfirm(-1, 0)"
            >
                {{ confirmText }}
            </v-btn>
        </template>
    </div>
</template>

<style>
    .border-right-radius-4 {
        border-bottom-right-radius: 4px !important;
        border-top-right-radius: 4px !important;
    }
</style>
